import Vue from "vue";
import * as Luxon from "luxon";
import { Buffer } from "buffer";
import ApexCharts from "vue-apexcharts";
import vuetify from "./plugins/vuetify";
import App from "./App.vue";
import router from "./plugins/router";
import { VueMaskDirective } from "v-mask";
import axios from "axios";

// @ts-ignore
window.Buffer = Buffer;

const token = localStorage.getItem("instream_panel_login_token");
if (token) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

// Global axios interceptor: redirect to login on 401 (expired/invalid token).
// Skipped if we're already on a public route (login, widget) so the public
// widget pages remain reachable even without a token.
axios.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err && err.response && err.response.status === 401) {
      try {
        const path = window.location.pathname || "";
        const isPublic =
          path.includes("/ui/login") ||
          path.includes("/ui/widget/") ||
          path.includes("/ui/programming/") ||
          path.includes("/widget/programming/");
        if (!isPublic) {
          localStorage.removeItem("instream_panel_login_token");
          localStorage.removeItem("instream_panel_user_data");
          delete (axios.defaults.headers.common as any)["Authorization"];
          // Hard redirect so the SPA fully resets state.
          const base = path.startsWith("/instream.panel") ? "/instream.panel/ui/login" : "/ui/login";
          window.location.replace(base);
        }
      } catch (_) {}
    }
    return Promise.reject(err);
  }
);

Vue.directive("mask", VueMaskDirective);
window["siteId"] = "instream.panel";
window["service"] = {
  base: "https://panel.instream.audio",
  ui: "https://panel.instream.audio/instream.panel/ui",
  api: "https://panel.instream.audio/instream.panel/api",
};

// Set default timezone from local storage (it'll also update later on in Navigation)
const timezone =
  localStorage.getItem("current_radio_timezone") ||
  "America/Argentina/Buenos_Aires";
Luxon.Settings.defaultZone = timezone;

Vue.config.productionTip = false;

Vue.config.errorHandler = (err: Error, vm: Vue, info: string) => {
  // Registrar el error en la consola para depuración (opcional)
  console.error("Error capturado:", err);

  // Puedes manejar el error aquí, por ejemplo, enviarlo a un servidor o mostrar una alerta
  // Si quieres evitar que los errores se muestren, simplemente no hagas nada aquí
};

(Vue.config as any).silent = true;

Vue.use(ApexCharts);
//Vue.use(VueMask)
Vue.component("apexchart", ApexCharts);

// Register PWA service worker on HTTPS (prod / preview).
if ("serviceWorker" in navigator && (location.protocol === "https:" || location.hostname === "localhost")) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch((e: Error) => {
      console.warn("[pwa] sw register failed", e && e.message);
    });
  });
}

// @ts-ignore
let params: any = {
  vuetify,
  router,
  render: (h) => h(App),
};
new Vue(params).$mount("#app");
